(() => {
  'use strict';

  const PRODUCT_SELECTOR =
    '.thb-product-detail.product';

  const INVENTORY_SELECTOR =
    '[id^="ProductInventoryData-"]';

  const AVAILABILITY_SELECTOR =
    'fieldset[data-handle="availability"]';

  const IN_STOCK = 'In stock';
  const MADE_TO_ORDER = 'Made-to-order';

  function getProductRoot() {
    return document.querySelector(
      PRODUCT_SELECTOR
    );
  }

  function getVariants() {
    const element = document.querySelector(
      INVENTORY_SELECTOR
    );

    if (!element) {
      console.error(
        'Availability: inventory JSON not found'
      );

      return [];
    }

    try {
      return JSON.parse(
        element.textContent
      );
    } catch (error) {
      console.error(
        'Availability: invalid inventory JSON',
        error
      );

      return [];
    }
  }

  function getSelectedValue(
    root,
    optionIndex
  ) {
    const fieldset = root.querySelector(
      `fieldset[data-index="option${optionIndex}"]`
    );

    if (!fieldset) {
      return '';
    }

    const radio = fieldset.querySelector(
      'input[type="radio"]:checked'
    );

    if (radio) {
      return radio.value;
    }

    return fieldset.querySelector(
      'select'
    )?.value || '';
  }

  function getControl(fieldset, value) {
    const input = [
      ...fieldset.querySelectorAll(
        'input[type="radio"]'
      )
    ].find((item) => item.value === value);

    return {
      input,
      label: input
        ? fieldset.querySelector(
            `label[for="${input.id}"]`
          )
        : null
    };
  }

  function show(control) {
    control.input?.style.removeProperty(
      'display'
    );

    control.label?.style.removeProperty(
      'display'
    );
  }

  function hide(control) {
    control.input?.style.setProperty(
      'display',
      'none',
      'important'
    );

    control.label?.style.setProperty(
      'display',
      'none',
      'important'
    );
  }

  function triggerThemeVariantUpdate(input) {
    input.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  function updateAvailability() {
    const root = getProductRoot();

    if (!root) {
      return;
    }

    const availability = root.querySelector(
      AVAILABILITY_SELECTOR
    );

    if (!availability) {
      return;
    }

    const option1 = getSelectedValue(
      root,
      1
    );

    const option2 = getSelectedValue(
      root,
      2
    );

    const variants = getVariants();

    const inStockVariant = variants.find(
      (variant) => {
        return (
          variant.option1 === option1 &&
          variant.option2 === option2 &&
          variant.option3 === IN_STOCK &&
          Number(
            variant.inventory_quantity
          ) > 0
        );
      }
    );

    const inStockExists =
      Boolean(inStockVariant);

    const inStockControl = getControl(
      availability,
      IN_STOCK
    );

    const madeToOrderControl = getControl(
      availability,
      MADE_TO_ORDER
    );

    if (
      !inStockControl.input ||
      !madeToOrderControl.input
    ) {
      return;
    }

    if (inStockExists) {
      /*
       * There is In stock inventory:
       * show only In stock.
       * Made-to-order inventory is irrelevant.
       */
      inStockControl.input.disabled = false;
      inStockControl.input.classList.remove(
        'is-disabled'
      );

      madeToOrderControl.input.disabled = true;
      madeToOrderControl.input.classList.add(
        'is-disabled'
      );

      show(inStockControl);
      hide(madeToOrderControl);

      if (!inStockControl.input.checked) {
        inStockControl.input.checked = true;
        triggerThemeVariantUpdate(
          inStockControl.input
        );
      }
    } else {
      /*
       * No In stock inventory:
       * show only Made-to-order.
       */
      inStockControl.input.disabled = true;
      inStockControl.input.classList.add(
        'is-disabled'
      );

      madeToOrderControl.input.disabled = false;
      madeToOrderControl.input.classList.remove(
        'is-disabled'
      );

      hide(inStockControl);
      show(madeToOrderControl);

      if (!madeToOrderControl.input.checked) {
        madeToOrderControl.input.checked = true;
        triggerThemeVariantUpdate(
          madeToOrderControl.input
        );
      }
    }
  }

  function init() {
    const root = getProductRoot();

    if (!root) {
      return;
    }

    let timer;

    function scheduleUpdate() {
      clearTimeout(timer);

      timer = window.setTimeout(
        updateAvailability,
        200
      );
    }

    root.addEventListener(
      'change',
      (event) => {
        const optionFieldset =
          event.target.closest(
            'fieldset[data-index]'
          );

        if (
          optionFieldset &&
          optionFieldset.dataset.index !==
            'option3'
        ) {
          scheduleUpdate();
        }
      }
    );

    window.setTimeout(
      updateAvailability,
      300
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();